import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import Icon from "@mui/material/Icon";

export default function NewProgram({ onClick }) {
  return (
    <MDBox
      onClick={onClick}
      sx={{
        width: "fit-content",
        paddingY: "8px",
        paddingX: "14px",
        borderRadius: "12px",
        cursor: "pointer",
        userSelect: "none",

        border: "1.5px solid",
        borderColor: "primary.main",
        backgroundColor: "primary.main",
        color: "white.main",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",

        transition: "all 0.18s ease",

        "&:hover": {
          backgroundColor: "primary.focus",
          borderColor: "primary.focus",
        },

        "&:active": {
          transform: "scale(0.98)",
        },
      }}
    >
      <Icon sx={{ fontSize: 18, color: "inherit" }}>add</Icon>

      <MDTypography
        sx={{
          fontSize: "0.85rem",
          fontWeight: 600,
          color: "inherit",
          lineHeight: 1,
        }}
      >
        Nueva rutina
      </MDTypography>
    </MDBox>
  );
}

NewProgram.propTypes = {
  onClick: PropTypes.func.isRequired,
};
